module.exports = __webpack_public_path__ + "img/mentora-logo.4169bf00.jpg";